import React, { Component } from "react";
import { connect } from "react-redux";
import "./mainpage.css";
import { Row, Col, UncontrolledCarousel } from "reactstrap";

import Heart_lights from "../../Images/heart-lights.jpg";
import Orb_lights from "../../Images/orb-lights.jpg";
import Dual_orb_lights from "../../Images/dual-orb-lights.jpg";
import Candle_lights from "../../Images/candle-lights.jpg";
import CEO_Image from "../../Images/CEO_image.jpg";

class MainPage extends Component {
  render() {
    return (
      <div>
        <Row>
          <Col sm="8" lx="8">
            <Row>
              <div className="Featured-buys">
                <h1>Best Sellers</h1>
                <UncontrolledCarousel
                  indicators={false}
                  autoPlay={true}
                  items={[

                    {
                      caption: "",
                      src: Orb_lights,

                      key: "3",
                    },
                    {
                      caption: "",
                      src: Dual_orb_lights,

                      key: "4",
                    },
                    {
                      caption: "",
                      src: Candle_lights,

                      key: "5",
                    },
                  ]}
                ></UncontrolledCarousel>
              </div>
            </Row>
          </Col>
          <Col sm="4" lx="4">
            <Row>
              <div className="Aboutme">
                <div className="Mainpage-aboutme-inner-container">
                  <img
                    className="Mainpage-ceo-image"
                    src={CEO_Image}
                    width="256px"
                    height="256px"
                    alt="ceo_image"
                  />
                </div>
                <p className="mainpage-aboutme-paragraph">
                  A lover of nature my pieces infuse the calm beautiful serenity of the world around us into your home.
                </p>
              </div>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    blogs: state.BlogReducer.blogs,
  };
};

export default connect(mapStateToProps)(MainPage);
